import styled from 'styled-components';

const Footer = styled.div`
  height: 64px;
`;

export default Footer;
